import React, { Component } from "react";

export default class NotFound extends Component {
  render() {
    return <div>404 Page.</div>;
  }
}
